import { GatsbyBrowser } from "gatsby";
import { ThemeProvider } from "./src/context/ThemeContext";
import { LocaleProvider } from "./src/context/LocaleContext";
import React from "react";

// export const wrapRootElement: GatsbyBrowser["wrapRootElement"] = ({ element }) => (
//   <ThemeProvider>{element}</ThemeProvider>
// )

export const wrapPageElement: GatsbyBrowser["wrapPageElement"] = ({ element, props }) => {
  return (
    <LocaleProvider {...props}>
      <ThemeProvider>{element}</ThemeProvider>
    </LocaleProvider>
  )
}
